import type { RouteObject } from "react-router";

import { ErrorBoundary } from "../../shared/components/ErrorBoundary";
import PractitionerReportsPage from "./ui/pages/PractitionerReportsPage";

/** Every therapist's and mentor's own reports. */
export const reportsRoutes: RouteObject[] = [
    {
        path: "/reports",
        element: (
            <ErrorBoundary>
                <PractitionerReportsPage />
            </ErrorBoundary>
        ),
    },
];
